import { c as _c } from "react/compiler-runtime";
import { CategoryScale, Chart as ChartJS, Tooltip as ChartTooltip, Filler, Legend, LineElement, LinearScale, PointElement, Title } from 'chart.js';
import React from 'react';
import { LeadsChartBox } from 'modules/main/components/chart-box-section/leads-chart-box';
import { RevenueChartBox } from 'modules/main/components/chart-box-section/revenue-chart-box';
import { ChartBoxSectionProps } from 'modules/main/components/chart-box-section/types';
ChartJS.register(CategoryScale, LinearScale, Filler, PointElement, LineElement, Title, Legend, ChartTooltip);
export const ChartBoxSection = React.forwardRef<HTMLDivElement, React.PropsWithRef<ChartBoxSectionProps>>(function ChartBoxSection(t0, ref) {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const t1 = `flex flex-col flex-wrap justify-between gap-5 md:flex-row lg:flex-col xl:gap-5 ${className} h-fit xl:flex-row`;
  let t2;
  let t3;
  if ($[3] !== props) {
    t2 = <LeadsChartBox {...props} />;
    t3 = <RevenueChartBox {...props} />;
    $[3] = props;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== ref || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div ref={ref} className={t1}>{t2}{t3}</div>;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
});